<template>
    <el-dialog title="添加产品" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
        :close-on-press-escape="false" width="50%">
        <div class="product-add pb50">
            <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
                <!-- 其他表单元素保持不变... -->
                
                <!-- 修改后的参数选择部分 -->
                <el-form-item label="选择参数">
                    <el-button type="primary" size="small" @click="openParamDialog">选择参数</el-button>
                </el-form-item>

                <!-- 参数弹窗 -->
                <div class="param-selector-overlay" v-if="paramOverlayVisible" @click.self="paramOverlayVisible = false">
                    <div class="param-selector-container">
                        <div class="param-selector-header">
                            <h3>选择参数</h3>
                            <el-button icon="el-icon-close" circle @click="paramOverlayVisible = false"></el-button>
                        </div>
                        
                        <div class="param-selector-body">
                            <div style="display: flex; height: 500px;">
                                <!-- 左侧分类菜单 -->
                                <div style="width: 200px; border-right: 1px solid #eee; padding-right: 10px; overflow-y: auto;">
                                    <el-checkbox-group v-model="selectedCategories" @change="handleCategoryChange">
                                        <div v-for="parent in parameterList" :key="'cat-'+parent.category_id" 
                                            style="padding: 8px 0; border-bottom: 1px solid #f0f0f0;">
                                            <el-checkbox :label="String(parent.category_id)" style="width: 100%;">
                                                {{ parent.name }}
                                                <span v-if="parent.child && parent.child.length > 0" style="margin-left: 5px; color: #999;">
                                                    ({{ parent.child.length }})
                                                </span>
                                            </el-checkbox>
                                        </div>
                                    </el-checkbox-group>
                                </div>
                                
                                <!-- 右侧参数表格 -->
                                <div style="flex: 1; padding-left: 20px; overflow-y: auto;">
                                    <div v-if="filteredParams.length === 0" style="text-align: center; margin-top: 100px; color: #999;">
                                        <i class="el-icon-warning" style="font-size: 24px;"></i>
                                        <p>请先选择左侧的分类</p>
                                    </div>
                                    
                                    <el-table 
                                        v-else
                                        :data="filteredParams" 
                                        border 
                                        @selection-change="handleSelectionChange"
                                        style="width: 100%"
                                        height="100%"
                                    >
                                        <el-table-column type="selection" width="55"></el-table-column>
                                        <el-table-column prop="category_name" label="所属分类" width="120"></el-table-column>
                                        <el-table-column prop="name" label="参数名称" width="180"></el-table-column>
                                        <el-table-column label="排序" width="120">
                                            <template v-slot="scope">
                                                <el-input-number 
                                                    v-model="scope.row.tempSort" 
                                                    :min="0" 
                                                    :controls="false"
                                                    size="small"
                                                    style="width: 100%"
                                                ></el-input-number>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="价格" width="150">
                                            <template v-slot="scope">
                                                <el-input 
                                                    v-model.number="scope.row.tempPrice" 
                                                    placeholder="0.00" 
                                                    size="small"
                                                    type="number"
                                                    step="0.01"
                                                >
                                                    <template slot="append">元</template>
                                                </el-input>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                        </div>
                        
                        <div class="param-selector-footer">
                            <el-button @click="paramOverlayVisible = false">取消</el-button>
                            <el-button type="primary" @click="saveSelectedParams" :disabled="selectedParams.length === 0">
                                确定 (已选 {{ selectedParams.length }} 个)
                            </el-button>
                        </div>
                    </div>
                </div>

                <el-form-item label="参数">
                    <el-table :data="form.hproducttoattrs" border size="mini" style="width: 100%;margin-top: 20px;">
                        <el-table-column prop="name" label="排序">
                            <template v-slot="scope">
                                <div class="d-s-c">
                                    <el-input style="width: 100px;" v-model="scope.row.sort"
                                        placeholder="请输入排序"></el-input>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="名称" width="200">
                            <template v-slot="scope">
                                <div class="d-s-c">
                                    {{ scope.row.name }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="价格" width="200">
                            <template v-slot="scope">
                                <div class="d-s-c">
                                    <el-input v-model="scope.row.price"></el-input>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="操作" width="100">
                            <template v-slot="scope">
                                <div style="color: blue;cursor: pointer;" @click="delPara(scope.$index)">删除</div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                
                <!-- 其他表单元素保持不变... -->
            </el-form>
        </div>
    </el-dialog>
</template>

<script>
    import HproductApi from '@/api/hproduct.js';
    import Upload from '@/components/file/Upload';
    import Categoryas from "@/components/categorya/index.vue";
    import draggable from "vuedraggable";
    import Uediter from '@/components/UE.vue';
    import { error } from 'shelljs';
    import StatisticsApi from '@/api/statistics.js';
    
    export default {
        components: {
            Upload: Upload,
            Categoryas,
            draggable,
            Uediter
        },
        data() {
            return {
                // 原有数据...
                
                // 新增的参数弹窗相关数据
                paramOverlayVisible: false,
                selectedCategories: [],
                selectedParams: [],
                filteredParams: [],
                preservedSelections: {},
                
                // 其他原有数据...
            };
        },
        methods: {
            // 原有方法...
            
            // 新增的参数弹窗相关方法
            openParamDialog() {
                console.log("完整parameterList数据:", JSON.stringify(this.parameterList, null, 2));
                this.paramOverlayVisible = true;
                
                if (this.parameterList && this.parameterList.length > 0) {
                    this.activeCategory = String(this.parameterList[0].category_id);
                    this.handleCategoryChange(this.activeCategory);
                }
            },
            
            handleCategoryChange(selectedCategoryIds) {
                console.log("选中的分类IDs:", selectedCategoryIds);
                
                this.filteredParams = this.parameterList
                    .filter(category => selectedCategoryIds.includes(String(category.category_id)))
                    .flatMap(category => {
                        return (category.child || []).map(param => ({
                            ...param,
                            category_name: category.name,
                            tempSort: param.sort || 0,
                            tempPrice: param.price || 0
                        }));
                    });
                
                console.log("合并后的参数列表:", this.filteredParams);
            },
            
            handleSelectionChange(selection) {
                this.selectedParams = selection;
            },
            
            saveSelectedParams() {
                if (!this.selectedParams || this.selectedParams.length === 0) {
                    this.$message.warning("请至少选择一个参数");
                    return;
                }

                const newParams = this.selectedParams
                    .filter(newParam => 
                        !this.form.hproducttoattrs.some(
                            existingParam => existingParam.id === newParam.id
                        )
                    )
                    .map(param => ({
                        id: param.id,
                        name: param.name,
                        category_id: param.category_id,
                        category_name: param.category_name,
                        sort: Number(param.tempSort) || 0,
                        price: Number(param.tempPrice) || 0,
                    }));

                if (newParams.length === 0) {
                    this.$message.warning("所选参数已存在");
                    return;
                }

                this.form.hproducttoattrs = [...this.form.hproducttoattrs, ...newParams];
                this.paramOverlayVisible = false;
                this.selectedParams = [];
                this.selectedCategories = [];
                this.filteredParams = [];
                
                this.$message.success(`成功添加 ${newParams.length} 个参数`);
            },
            
            // 其他原有方法...
        }
    };
</script>

<style>
    /* 原有样式... */
    
    /* 新增的参数弹窗样式 */
    .param-selector-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0,0,0,0.5);
        z-index: 2000;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .param-selector-container {
        width: 80%;
        height: 80%;
        background: white;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
    }

    .param-selector-header {
        padding: 15px 20px;
        border-bottom: 1px solid #eee;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .param-selector-body {
        flex: 1;
        overflow: hidden;
        display: flex;
    }

    .param-selector-footer {
        padding: 15px 20px;
        border-top: 1px solid #eee;
        text-align: right;
    }
</style>


// WEBPACK FOOTER //
// src/views/plus/hproduct/index/part/add1.vue